module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thumbnail",
    style: ({
      backgroundImage: 'url(\'' + _vm.imageUrl + '\')'
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4039940"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/components/images/components/common/thumbnail.vue
// module id = 559
// module chunks = 0